/*
$(function() {
	AOS.init({
		once: true
	})
});
$(window).on('load', function() {
  AOS.refresh();
});
*/
$(document).ready(function(e) { 
	(function($) {
          'use strict';
          // call our plugin
          var Nav = new hcOffcanvasNav('#main-nav #menu-main-menu', {
            disableAt: false,
            customToggle: '.toggle',
            levelSpacing: 50,
            //navTitle: 'All Categories',
            levelTitles: true,
            levelTitleAsBack: true,
            pushContent: '#container-box',
            labelClose: false
          });

    })(jQuery);
	/*-------------*/

	$(".nav-box a").mouseenter(function(){
		$('.menu-drop-down').addClass('active');
		$('.menu-drop-item').removeClass('active'); 
		$(".nav-box a").removeClass('link-active');
		var mid = "#"+$(this).attr('data-menu');
		if(mid){
			//$(mid).siblings().removeClass('active');
			$(mid).addClass('active'); 
		}
	});
	$(".dropdown").mouseenter(function(){
		$(this).addClass('link-active');
	});
	$(".menu-drop-item").mouseleave(function(){
		 $('.menu-drop-item').removeClass('active'); 
		 $('.menu-drop-down').removeClass('active');
	});
	$(".menu-drop-item").mouseleave(function(){
		$(".nav-box a").removeClass('link-active');
	});
	/*$(".dropdown").click(function(){
		return false;
	});*/

	/* ----- Search Bar Controls (Updated) ----- */
	$("#search-btn").click(function(){
		$('.menu-drop-down').removeClass('active');
		$(".nav-box a").removeClass('link-active');
		$("#search-menu").toggleClass('active');
		// Auto-focus input when opened
		if ($("#search-menu").hasClass('active')) {
			setTimeout(function() {
				$("#search-menu input[type='search'], #search-menu input[type='text']").first().focus();
			}, 100);
		}
		return false;
	});

	$("#search-close").click(function(){
		$("#search-menu").removeClass('active');
		$("#search-btn").focus();
		return false;
	});

	// Close on outside click
	$(document).on('click', function (e) {
		if ($(e.target).closest("#search-menu, #search-btn").length === 0) {
			$("#search-menu").removeClass('active');
		}
	});

	// Close on Escape key press (WCAG Accessibility & UX fix)
	$(document).on('keyup', function (e) {
		if ((e.key === 'Escape' || e.keyCode === 27) && $("#search-menu").hasClass('active')) {
			$("#search-menu").removeClass('active');
			$("#search-btn").focus();
		}
	});
	
	if($('.img-slider').length){
		$('.img-slider').owlCarousel({
			autoplay:true,
			dots: true,
			nav: false,
			navText: [ '<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>' ],
			rewind:true,
			autoplayTimeout:5000,
			loop:true,
			center:false,
			items:1,
			margin:0,
			responsive:{
			  200:{ items:1 },
			  480:{ items:1 },
			  767:{ items:1 },
			  991:{ items:1 }
			}
		});
	}
	
});
